export class Pawn {
    x;
    y;
    layer;
    color;
    viewColor;
    player;

    constructor(x, y, color, player) {
        this.x = x;
        this.y = y;
        this.layer = 1;
        this.color = color;
        this.viewColor = color;
        this.player = player;
    }




}